import { SUBTIER_SOURCE_SYSTEM } from './constants';

const getExtraGoldenRecordFields = (subtier, user) => {
  return {
    "tierLevel": subtier.tierLevel,
    "productType": subtier.productType,
    "isDiverseEnterprise": subtier.isDiverseEnterprise,
    "supplierNumbers": [subtier.supplierNo],
    "createdBy": user,
    "sourceSystem": SUBTIER_SOURCE_SYSTEM
 }
}

export { getExtraGoldenRecordFields};